export const currentEnvByUrl = (): string => {
    // Loop to find env, if none then it's prod
    const envs = ["local", "qat", "uat"];
    let currentEnv = "prod";

    for(let i=0; i<envs.length; i++) {
        if (window.location.origin.indexOf(envs[i]) > -1) {
            currentEnv = envs[i];
            break;
        }
    }

    return currentEnv;
};

export const createEnvUrlString = (): string => {
    const currentEnv = currentEnvByUrl();
    switch (currentEnv) {
        case "local":
            return "-dev";
        case "prod":
            return "";
        default:
            return "-" + currentEnv;//qat, uat
    }
};

export const createEnvUrlStringForPersona = (): string => {
    const currentEnv = currentEnvByUrl();
    switch (currentEnv) {
        case "local":
            return "-local";
        case "prod":
            return "";
        default:
            return "-" + currentEnv;//qat, uat
    }
};
